/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const SnoozeIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M18.5,19.5 L18.5,15 C18.5,12.297 16.848,9.979 14.5,9 C14.5,7.619 13.379,6.5 12,6.5 C10.617,6.5 9.5,7.619 9.5,9 C7.149,9.979 5.5,12.297 5.5,15 L5.5,19.5 C5.5,20.604 4.604,21.5 3.5,21.5 L20.5,21.5 C19.395,21.5 18.5,20.604 18.5,19.5 Z" />
      <path d="M14,21.5 C14,22.604 13.104,23.5 12,23.5 C10.895,23.5 10,22.604 10,21.5" />
      <polyline points="0.5 6.5 3.5 6.5 0.5 9.5 3.5 9.5" />
      <polyline points="9.5 1.5 11.5 1.5 9.5 3.5 11.5 3.5" />
      <polyline points="19.5 3.5 23.5 3.5 19.5 7.5 23.5 7.5" />
    </g>
  </svg>
);

export default SnoozeIcon;
